export const firebaseConfig = {
  apiKey: 'AIzaSyAxq558mJL7LO47685W5_zzXvWInjSAVcA',
  authDomain: 'remindworksadmin.firebaseapp.com',
  databaseURL: 'https://remindworksadmin.firebaseio.com',
  projectId: 'remindworksadmin',
  storageBucket: 'remindworksadmin.appspot.com',
  messagingSenderId: '891927727947',
  appId: '1:891927727947:web:efd6dc27dac7346d85e2ce',
}
